<template>
  <div class="upload-box">
    <b-form-checkbox
        v-model="CompressFile "
        class="mb-2"
        switch
    >
      فشرده نشود
    </b-form-checkbox>
    <drop-zone
        :accept="accept"
        :multiple="multiple"
        :disabled="status !== 'none'"
        class="h-50"
        @change="upload"
    >
      <div v-if="status === 'none'" class="w-100">
        <feather-icon icon="PlusIcon" size="30" style="margin-bottom: 10px" />
        <div class="font-small-2"> فایل را اینجا رها کنید</div>
      </div>
      <div v-else-if="status === 'uploading'" class="w-100">
        <div class="font-small-2 text-left" style="margin-bottom: 3px">{{`در حال اپلود... ${progress}%`}}</div>
        <b-progress
            v-model="progress"
            max="100"
        />
      </div>
      <div v-else-if="status === 'failed'">
        <div class="font-small-1 text-danger" style="margin-bottom: 5px">آپلود با خطا مواجه شد</div>
        <b-button variant="flat" style="padding: 3px" @click="upload(file)">
          <feather-icon
              icon="RotateCcwIcon"
              class="mr-50"
          />
          <span class="align-middle font-small-2">تلاش مجدد</span>
        </b-button>
        <b-button variant="flat" style="padding: 3px" @click="reset">
          <feather-icon
              icon="XIcon"
              style="margin-left: 5px"
          />
          <span class="align-middle font-small-2">لغو</span>
        </b-button>
      </div>
    </drop-zone>
  </div>
</template>

<script>
import DropZone from "@/tools/media/dropZone.vue";

export default {
  name: "fmUploadFile",
  components: { DropZone },
  props: {
    accept: { type: String, default: '*/*' },
    multiple: { type: Boolean, default: false },
    entity: { type: [String, Number], default: '' }
  },
  data() {
    return {
      loading: false,
      file: null,
      progress: 0,
      status: 'none',
      CompressFile: false
    }
  },
  methods: {
    upload(file) {
      if (this.entity === '' || this.entity === null) return
      this.file = file
      let data = new FormData()
      data.append('Entity', this.entity)
      data.append('File', file)
      data.append('CompressFile', this.CompressFile)
      this.status = 'uploading'
      this.$http.post(this.$api.fileManager.upload, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: e => (this.progress = (e.loaded * 100) / e.total)
      }).then(() => {
        this.status = 'none'
        this.progress = 100
        this.$emit('update')
      }).catch(() => {
        this.status = 'failed'
      })
    },
    reset() {
      this.file = null
      this.status = 'none'
      this.progress = 0
    }
  }
}
</script>

<style lang="scss">
.upload-box {
  width: 120px;
  height: 120px;
  margin: 5px;
  .media-zone {
    padding: 5px;
  }
}
</style>